export const keys = {
  options: Symbol() as InjectionKey<OwnbitConfigurator.PluginOptions>,
  disabled: Symbol() as InjectionKey<Ref<boolean>>,
}
